export default "__VITE_ASSET__$Le0LPNG__"